import { Box } from "@mui/material";
import { tokens } from "../../theme";


import PageGuard from "../../components/PageGuard";
import { useRedfidViews } from "../../utils/redfidView";
import LoadingState from "../../components/LoadingState";



const Historial = () => {
  const colors = tokens();
  const { loading, error} = useRedfidViews();

  if (loading) return <LoadingState message="" />;
  if (error) return <div>Error cargando datos: {String(error)}</div>;

  return (
    <PageGuard title="Mi Actividad" subtitle="Resumen de Actividades">
      <Box m="20px" ml="5px" pb="100px">
        <Box
          mt="20px"
          height="80vh"
          sx={{
            "& .MuiDataGrid-root": { border: "none" },

            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: colors.green[200],
              borderBottom: "1px solid rgba(0,0,0,0.10)",
            },
            "& .MuiDataGrid-columnHeaderTitle": {
              fontWeight: 900,
              fontSize: "14px",
              color: colors.primary[200],
            },

            "& .MuiDataGrid-cell": {
              borderBottom: "1px solid rgba(0,0,0,0.06)",
              fontSize: "14px",
            },

            "& .MuiTablePagination-root": { fontSize: "14px" },
            "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows": {
              fontSize: "14px",
              fontWeight: 800,
            },
            "& .MuiTablePagination-select": { fontSize: "14px" },
            "& .MuiSvgIcon-root": { fontSize: "22px" },

            "& .MuiDataGrid-virtualScroller": {
              backgroundColor: colors.primary[200],
            },
            "& .MuiDataGrid-footerContainer": {
              borderTop: "1px solid rgba(0,0,0,0.08)",
              backgroundColor: colors.primary[200],
            },
          }}
        >
          
        </Box>
      </Box>
    </PageGuard>
  );
};

export default Historial;
